'use client'

import React, { createContext, useCallback, useEffect, useState } from 'react'

const SessionExpiresContext = createContext({
  logout: () => {}
})

export function SessionExpiresProvider({ children }: { children: React.ReactNode }) {
  const [expiresAt, setExpiresAt] = useState<number | null>(null)

  const logout = useCallback(() => {
    const a = document.createElement('a')

    a.href = '/auth/logout'
    a.click()
  }, [])

  useEffect(() => {
    fetch('/api/auth/expires')
      .then((resp) => resp.json())
      .then((data) => {
        if (data.expiresAt) {
          setExpiresAt(data.expiresAt)

          return
        }
      })
  }, [])

  useEffect(() => {
    if (!expiresAt) return

    const checkExpiration = () => {
      const currentTime = Math.floor(Date.now() / 1000)

      if (expiresAt < currentTime) {
        // displayDefaultError(ERROR_MESSAGES.UNAUTHORIZED)
        logout()
      }
    }

    // Verificar inmediatamente
    checkExpiration()

    // Configurar un intervalo para verificar cada 1.5 minutos
    const interval = setInterval(checkExpiration, 3000)

    return () => clearInterval(interval)
  }, [expiresAt, logout])

  return (
    <SessionExpiresContext.Provider value={{ logout }}>{children}</SessionExpiresContext.Provider>
  )
}

export default SessionExpiresContext
export function useSessionExpires() {
  return React.useContext(SessionExpiresContext)
}
